class DeferredPopupMedia extends HTMLElement {
    constructor() {
        super();
        this.container = this.closest('.video-walkthrough .container');
        this.addListeners();
    }

    addListeners() {
        const loadBtn = this.querySelector('.js-load-media');
        if (loadBtn) {
            loadBtn.addEventListener('click', this.loadContentInPopup.bind(this));
        }
    }

    /**
     * Loads the deferred media.
     * @param {boolean} [focus=true] - Focus the deferred media element after loading.
     * @param {boolean} [pause=true] - Whether to pause all media after loading.
     * @param {string} [loadTrigger='click'] - The action that caused the deferred content to load.
     */
    loadContentInPopup(focus = true, pause = true, loadTrigger = 'click') {
        if (pause) pauseAllMedia();

        this.loadTrigger = loadTrigger;
        const content = this.querySelector('template').content.firstElementChild.cloneNode(true);
        const modal = document.createElement('div');
        const modalBg = document.createElement('div');
        const modalBody = document.createElement('div');
        const modalClose = document.createElement('button');
        const pauseProductAudioEvent = new Event('product:audio:pause');
        const pauseSoundbarAudioEvent = new Event('soundbar:pause');

        document.dispatchEvent(pauseProductAudioEvent);
        document.dispatchEvent(pauseSoundbarAudioEvent);

        modalClose.className = 'modal__close-btn';
        modalClose.innerHTML = '<span aria-hidden="true">×</span>';
        modalBg.className = 'modal-background';
        modalBody.className = 'modal-body';
        modal.className = 'modal';
        modalBody.appendChild(content);
        modal.appendChild(modalBg);
        modal.appendChild(modalBody);
        modal.appendChild(modalClose);
        this.appendChild(modal);

        setTimeout(function() {
            document.querySelector('body').classList.add('overflow-hidden');
            modal.classList.add('yt');
            modal.classList.add('show');
        }, 50);

        this.setAttribute('loaded', '');

        const deferredEl = this.querySelector('video, model-viewer, iframe');
        if (deferredEl && focus) deferredEl.focus();

        modal.addEventListener('click', this.dismissPopup.bind(this));
    }

    dismissPopup(event) {
        const target = event.target;
        const modal = target.closest('.modal');
        const video = modal.querySelector('.js-youtube');
        const component = video.closest('video-component');

        if (component && component.dataset.background === 'true') return;

        modal.classList.remove('show');
        document.querySelector('body').classList.remove('overflow-hidden');

        setTimeout(function() {
            video.contentWindow.postMessage('{ "event": "command", "func": "pauseVideo", "args": "" }', '*');
            modal.remove();
        }, 100);
    }
}

customElements.define('deferred-popup-media', DeferredPopupMedia);